! function (t, e) {
   "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).AutosuggestSDK = {})
}(this, function (t) {
   "use strict";
   class e {
      constructor() {
         this.state = {
            query: "",
            response: {
               initialRequestProducts: [],
               products: [],
               trendingSearches: [],
               popularProducts: [],
               inFields: [],
               keywordSuggestions: [],
               promotedSuggestions: [],
               topSearchQueries: [],
               prefetchedSearchResults: {}
            },
            dom: {
               inputBox: null,
               autosuggestionBox: null
            }
         }
      }
      getState(t) {
         if (!t) return this.state;
         const e = t.split(".");
         let s = this.state;
         for (const t of e) s = s?.[t];
         return s
      }
      updateState(t, e, s = this.state) {
         try {
            let o = t.split("__"),
               n = o[0],
               r = o.slice(1),
               i = {
                  ...s
               };
            return Object.entries(s).forEach(([t, s]) => {
               t === n && (o.length > 1 ? i[t] = this.updateState(r.join("__"), e, s) : i[t] = e)
            }), s === this.state ? (this.state = i, this.state) : (i)
         } catch (t) {
            throw console.error("StateManager updateState error", t), t
         }
      }
   }
   const s = {
         siteKey: "",
         apiKey: "",
         inputBoxConfigs: {
            searchInput: null,
            debounceDelay: 0,
            minChars: 3
         },
         suggestionBoxConfigs: {
            containerTag: "div",
            attributes: {
               class: "unx-autosuggest-box"
            },
            template: null
         },
         apiConfigs: {
            apiEndpoint: "https://search.unbxd.io",
            initialRequest: !1,
            inFields: {
               count: 2
            },
            popularProducts: {
               count: 3,
               fields: []
            },
            keywordSuggestions: {
               count: 2
            },
            topQueries: {
               count: 2
            },
            promotedSuggestions: {
               count: 2
            },
            trendingSearches: {
               count: 5
            },
            search: {
               prefetch: !1,
               filterField: ""
            }
         },
         onEvent: function ({
            eventType: t
         }) {
            console.log(`Unbxd Running onEvent with ${t}`)
         }
      },
      o = (t, e) => {
         if (!e || 0 === Object.keys(e).length) return t;
         if (!t || 0 === Object.keys(t).length) return e;
         let s = {};
         return Object.entries(t).forEach(([n, r]) => {
            s[n] = "object" == typeof r && null !== r ? "attributes" === n ? {
               ...t[n],
               ...e[n]
            } : o(t[n], e[n]) : e[n] ?? r
         }), s
      };
   class n {
      constructor({
         configs: t
      }) {
         this.configs = o(s, t)
      }
      getConfigs(t) {
         if (!t) return this.configs;
         const e = t.split(".");
         let s = this.configs;
         for (const t of e) s = s?.[t];
         return s
      }
      isRequired(t) {
         return ["siteKey", "apiKey", "searchInput"].includes(t)
      }
      updateConfigs(t) {
         this.configs = o(s, t)
      }
   }
   const r = "BEFORE_TRENDING_SEARCHES_API_CALL",
      i = "AFTER_TRENDING_SEARCHES_API_CALL",
      u = "BEFORE_AUTOSUGGEST_API_CALL",
      a = "AFTER_AUTOSUGGEST_API_CALL",
      g = "AUTOSUGGEST_QUERY_UPDATED",
      c = "INPUT_FOCUS",
      h = "INPUT_BLUR",
      l = "ERROR";
   class d {
      constructor({
         configurations: t = {},
         setState: e = () => {},
         getState: s = () => {},
         onAutosuggestionRequest: o = () => {},
         onSearchRequest: n = () => Promise.resolve(),
         renderSuggestions: r = () => {},
         renderPopularProductsOnly: i = () => {},
         clearSuggestions: u = () => {}
      }) {
         this.configs = t, this.localState = {
            configs: t,
            inputBox: null,
            autosuggestionBox: null,
            lastHoveredSuggestionValue: void 0
         }, this.utilities = {
            setState: e,
            getState: s,
            clearSuggestions: u,
            onAutosuggestionRequest: o,
            onSearchRequest: n,
            renderSuggestions: r,
            renderPopularProductsOnly: i
         }, this.setState = e, this.getState = s, this.onAutosuggestionRequest = o, this.onSearchRequest = n, this.renderSuggestions = r, this.renderPopularProductsOnly = i, this.clearSuggestions = u, this._lastHoveredSuggestionValue = void 0;
         const a = this.configs?.inputBoxConfigs?.debounceDelay ?? 0;
         this.debouncedAutosuggestRequest = a > 0 ? function (t, e) {
            let s;
            return function (...o) {
               clearTimeout(s), s = setTimeout(() => {
                  t.apply(this, o)
               }, e)
            }
         }(t => this.onAutosuggestionRequest(t), a) : null, this.initializeDOM(), this.attachAutosuggestEvents()
      }
      klaviyo_review(){
         if(window.klReviewsObject){
            self.klReviewsObject.renderWidgets();
         }
      }
      initializeDOM() {
         try {
            this.inputBox = document.querySelector(this.configs?.inputBoxConfigs?.searchInput) || null, this.autosuggestionBox = this.createAutosuggestionBox(), this.setState("dom__inputBox", this.inputBox), this.setState("dom__autosuggestionBox", this.autosuggestionBox)
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("DOMService initializeDOM error", t)
         }
      }
      OldcreateAutosuggestionBox() {
         try {

            let tag = this.configs?.suggestionBoxConfigs?.containerTag || "div";

            let attrs = {
               ...(this.configs?.suggestionBoxConfigs?.attributes || {})
            };

            // Try to reuse existing element by class
            let existing = null;

            if (attrs.class) {
               existing = document.querySelector("." + attrs.class.trim().replace(/\s+/g, "."));
            }
            // console.log("existing",existing)
            if (existing) {
               return existing;
            }

            // Else create new one
            let el = document.createElement(tag);

            Object.entries(attrs).forEach(([key, val]) => {
               const value = Array.isArray(val) ? val.join(" ") : val;
               el.setAttribute(key, value);
            });

            return el;

         } catch (error) {
            console.error("createAutosuggestionBox error", error);
            return null;
         }
      }
      createAutosuggestionBox() {
         try {
            let t = this.configs?.suggestionBoxConfigs?.containerTag,
               e = {
                  ...this.configs?.suggestionBoxConfigs?.attributes || {}
               },
               s = document.createElement(t);
            return Object.entries(e).forEach(([t, e]) => {
               const o = Array.isArray(e) ? e.join(" ") : e;
               s.setAttribute(t, o)
            }), s
         } catch (t) {
            return this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("DOMService createAutosuggestionBox error", t), null
         }
      }
      getEventsToBeAttached() {
         return [{
            target: this.inputBox,
            action: "input",
            handler: this.onInputChange.bind(this)
         }, {
            target: this.inputBox,
            action: "focus",
            handler: this.onInputFocus.bind(this)
         }, {
            target: this.inputBox,
            action: "blur",
            handler: this.onInputBlur.bind(this)
         }, {
            target: document,
            action: "click",
            handler: this.onDocumentClick.bind(this)
         }, {
            target: this.autosuggestionBox,
            action: "mouseover",
            handler: this.onAutosuggestionBoxHover.bind(this)
         }, {
            target: this.inputBox,
            action: "keydown",
            handler: this.onInputKeyDown.bind(this)
         }]
      }
      attachAutosuggestEvents() {
         try {
            this.getEventsToBeAttached().forEach(t => {
               let {
                  target: e,
                  action: s,
                  handler: o
               } = t;
               e && e.addEventListener(s, o)
            })
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("DOMService attachEvents error", t)
         }
      }
      onInputChange(t) {
         // console.log(t, "oninputchange")
         try {
            let e = (t.target.value || "")?.trim();
            const {
               query: s
            } = this.getState() || {};
            if (e === s) return;
            console.log(this.setState("query", e), "query")
            this.setState("query", e), this.configs?.onEvent?.({
               eventType: g,
               query: e
            });
            const {
               minChars: o
            } = this.configs?.inputBoxConfigs || {};
            if (0 === e.length || e.length < o) return this.clearSuggestions(), void this.unmountAutosuggestionBox();
            this.debouncedAutosuggestRequest ? this.debouncedAutosuggestRequest({
               query: e
            }) : this.onAutosuggestionRequest({
               query: e
            })
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("onInputChange error", t)
         }
      }
      onInputFocus(t) {
         try {
            const e = (t.target.value || "")?.trim(),
               {
                  minChars: s
               } = this.configs?.inputBoxConfigs || {},
               o = null != s ? s : 3;
            if (!e || e.length < o) return void this.unmountAutosuggestionBox();
            this.configs?.onEvent?.({
               eventType: c
            }), this.setState("query", e), this.renderSuggestions()
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("onInputFocus error", t)
         }
      }
      onInputBlur() {
         try {
            this.configs?.onEvent?.({
               eventType: h
            }), this.unmountAutosuggestionBox()
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error(t)
         }
      }
      onDocumentClick(t) {
         try {
            const e = t.target,
               s = this.inputBox && this.inputBox.contains(e),
               o = this.autosuggestionBox && this.autosuggestionBox.contains(e);
            s || o || this.autosuggestionBox && this.unmountAutosuggestionBox()
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("onDocumentClick error", t)
         }
      }
      onInputKeyDown(t) {
         try {
            "Enter" === t.key && this.unmountAutosuggestionBox()
         } catch (t) {
            console.error("onInputKeyDown error", t)
         }
      }
      async onAutosuggestionBoxHover(t) {
         try {
            const {
               target: e
            } = t, s = ["INFIELD_SUGGESTION", "KEYWORD_SUGGESTION", "PROMOTED_SUGGESTION", "TOP_SEARCH_QUERY", "TOP_SEARCH_QUERIES"];
            if (!e.classList.contains("unx-item") || !s.includes(e.dataset.doctype)) return;
            const o = e.dataset.value;
            if (o === this._lastHoveredSuggestionValue) return;
            this._lastHoveredSuggestionValue = o;
            const n = this.getState("response.prefetchedSearchResults") || {},
               r = this.configs?.apiConfigs?.search?.prefetch ?? !1;
            if (void 0 !== n[o]) return this.setState("response__popularProducts", n[o] ?? []), void this.renderPopularProductsOnly();
            if (!r) {
               const t = o.indexOf(":"),
                  e = t >= 0 ? o.slice(0, t) : o,
                  s = t >= 0 ? o.slice(t + 1) : null;
               await this.onSearchRequest({
                  query: e,
                  filters: s ? [s] : []
               })
            }
            const i = this.getState("response.prefetchedSearchResults") || {};
            this.setState("response__popularProducts", i[o] ?? []), this.renderPopularProductsOnly()
         } catch (t) {
            console.error("onAutosuggestionBoxHover error", t)
         }
      }
      updateSuggestionBoxHTML(t = "") {
         try {
            this.autosuggestionBox.innerHTML = t
            this.klaviyo_review();
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("updateSuggestionBoxHTML error", t)
         }
      }
      updatePopularProductsSection(t = "") {
         try {
            const e = this.autosuggestionBox?.querySelector(".unx-popular-products");
            e && (e.innerHTML = t)
            this.klaviyo_review();
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("updatePopularProductsSection error", t)
         }
      }
      mountAutosuggestionBox() {
         try {
            "" !== this.autosuggestionBox?.innerHTML?.trim() ? this.inputBox.after(this.autosuggestionBox) : this.unmountAutosuggestionBox()
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("mountAutosuggestionBox error", t)
         }
      }
      unmountAutosuggestionBox() {
         try {
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("unmountAutosuggestionBox error", t)
         }
      }
   }
   class p {
      constructor({
         configurations: t,
         setState: e,
         getState: s
      }) {
         this.configs = t, this.setState = e, this.getState = s || (() => ({})), this.fireInitialRequest()
      }
      fireInitialRequest() {
         const t = this.configs?.apiConfigs?.initialRequest,
            e = this.configs?.apiConfigs?.trendingSearches?.count;
         t && this.fireAutosuggestRequest({
            query: "*",
            initialCall: !0
         }), e > 0 && this.fireTrendingSearchesRequest()
      }
      buildAutosuggestURL({ query: t }) {
         try {
            const {
                  siteKey: e,
                  apiKey: s,
                  apiConfigs: {
                     apiEndpoint: o,
                     inFields: n,
                     popularProducts: r,
                     keywordSuggestions: i,
                     topQueries: u,
                     promotedSuggestions: a
                  } = {}
            } = this.configs || {};
            //FIX: normalize + encode
            let safeQuery;
            try {
                  safeQuery = encodeURIComponent(decodeURIComponent(t || ""));
            } catch {
                  safeQuery = encodeURIComponent(t || "");
            }
            return `${o}/${s}/${e}/autosuggest?q=${safeQuery}&version=V2` +
                  `&inFields.count=${n?.count}` +
                  `&keywordSuggestions.count=${i?.count}` +
                  `&popularProducts.count=${r?.count}` +
                  (r?.fields?.length > 0 ? `&popularProducts.fields=${encodeURIComponent(r.fields.join(","))}` : "") +
                  `&topQueries.count=${u?.count}` +
                  `&promotedSuggestions.count=${a?.count}`;
         } catch (err) {
            console.error("buildAutosuggestURL error", err);
            throw err;
         }
      }
      buildTrendingSearchesURL() {
         try {
            const {
               siteKey: t,
               apiKey: e,
               apiConfigs: {
                  apiEndpoint: s
               } = {}
            } = this.configs || {};
            return new URL(`${s}/${e}/${t}/autosuggest?trending-queries=true&q=*`)
         } catch (t) {
            throw console.error("APIService buildTrendingSearchesURL error", t), t
         }
      }
      //  MUST be inside class
      buildSearchUrl({ query: t, filter: e = "" }) {
         const {
            siteKey: s,
            apiKey: o,
            apiConfigs: { popularProducts: n, search: r }
         } = this.configs || {};
         const i = r?.fields?.length > 0 ? r.fields : n?.fields;
         const safeQuery = encodeURIComponent(t || "");
         let url = `https://search.unbxd.io/${o}/${s}/search?q=${safeQuery}&rows=${n?.count || 8}&indent=off&facet=off&analytics=false&redirect=false`;
         if (i?.length > 0) {
            url += `&fields=${i.join(",")}`;
         }
         if (e) {
            url += `&filter=${encodeURIComponent(e)}`;
         }
         const uid = typeof window.getUnbxdUserId === "function" ? window.getUnbxdUserId() : "";
         if (uid) {
            url += `&uid=${encodeURIComponent(uid)}`;
         }
         return url;

      }
      async request(t = "AUTOSUGGEST", e = {}) {
         try {
            let s = "SEARCH" === t ? this.buildSearchUrl(e) : "TRENDING_SEARCHES" === t ? this.buildTrendingSearchesURL() : this.buildAutosuggestURL(e);
            const headers = {};
            const uid = typeof window.getUnbxdUserId === "function" ? window.getUnbxdUserId() : "";
            if (uid) {
               headers["unbxd-user-id"] = uid;
            }
            const o = await fetch(s, {
               method: "GET",
               headers: headers
            });
            return await o.json()
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("Unbxd Autosuggest APIService request error", t)
         }
      }
      async fireTrendingSearchesRequest() {
         try {
            if (this.configs?.apiConfigs?.trendingSearches?.count <= 0) return;
            this.configs?.onEvent?.({
               eventType: r
            });
            const t = await this.request("TRENDING_SEARCHES");
            if (this.configs?.onEvent?.({
                  eventType: i
               }), t?.response?.products) {
               const e = this.configs?.apiConfigs?.trendingSearches?.count;
               this.setState("response__trendingSearches", t.response.products.slice(0, e))
            }
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("setupTrendingSearches error", t)
         }
      }
      async fireAutosuggestRequest({
         query: t,
         initialCall: e = !1
      }) {
         try {
            this.configs?.onEvent?.({
               eventType: u,
               query: t
            });
            
            const s = await this.request("AUTOSUGGEST", {
               query: t
            }) || {};
            if (this.configs?.onEvent?.({
                  eventType: a,
                  query: t
               }), s?.response?.products)
               if (e) this.setState("response__initialRequestProducts", s?.response?.products || []);
               else {
                  const t = (t => {
                     try {
                        let e = {};
                        return (Array.isArray(t) ? t : []).forEach(t => {
                           e[t?.doctype] ? e[t?.doctype].push(t) : e[t?.doctype] = [t]
                        }), e
                     } catch (t) {
                        return console.error("getSortedProducts error", t), {}
                     }
                  })(s?.response?.products);
                  this.setState("response__products", s?.response?.products), this.setState("response__popularProducts", t?.POPULAR_PRODUCTS), this.setState("response__inFields", t?.IN_FIELD), this.setState("response__keywordSuggestions", t?.KEYWORD_SUGGESTION), this.setState("response__promotedSuggestions", t?.PROMOTED_SUGGESTION), this.setState("response__topSearchQueries", t?.TOP_SEARCH_QUERIES)
               }
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("setupAutosuggest error", t)
         }
      }
      async fireSearchRequest({
         query: t,
         filters: e = []
      }) {
         try {
            const s = await this.request("SEARCH", {
                  query: t
               }),
               o = {};
            if (o[t] = s.response.products, e.length > 0) {
               const s = this.configs?.apiConfigs?.search?.filterField,
                  n = e.map(e => this.request("SEARCH", {
                     query: t,
                     filter: `${s}: "${e}"`
                  })),
                  r = await Promise.all(n),
                  i = {
                     ...o
                  };
               r.forEach((s, o) => {
                  i[`${t}:${e[o]} `] = s.response.products
               }), this.setState("response__prefetchedSearchResults", {
                  ...this.getState("response.prefetchedSearchResults"),
                  ...i
               })
            }
            this.setState("response__prefetchedSearchResults", {
               ...this.getState("response.prefetchedSearchResults"),
               ...o
            })
         } catch (t) {
            this.configs?.onEvent?.({
               eventType: l,
               error: t
            }), console.error("fireSearchRequest error", t)
         }
      }
   }

   function S({
      IN_FIELD: t = []
   }) {
      if (0 === t.length) return "";
      return `<div class="unx-infield-suggestions">${t.map(t=>{const e=t[this.configurations.apiConfigs.search.filterField+"_in"];let s="";return e?.length>0&&(s=`${e.map(e=>`<span class="unx-item" data-doctype="INFIELD_SUGGESTION" data-value="${t}:${e}">In ${e}</span>`).join("\n")}`),`<div class="unx-item unx-infield-suggestion" data-doctype="INFIELD_SUGGESTION" data-value="${t.autosuggest}">${t.autosuggest}${s?" "+s:""}</div>`}).join("")}</div>`
   }

   function f({
      KEYWORD_SUGGESTION: t = []
   }) {
      if (0 === t.length) return "";
      return `<div class="unx-keyword-suggestions">${t.map(t=>`<div class="unx-item unx-keyword-suggestion" data-doctype="KEYWORD_SUGGESTION" data-value="${t.autosuggest}">${t.autosuggest}</div>`).join("")}</div>`
   }
   
function getCurrencySymbol(currencyCode) {
    try {
        const parts = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currencyCode,
            currencyDisplay: 'narrowSymbol'  // ✅ gives S$ not SGD
        }).formatToParts(0);
        const symbolPart = parts.find(p => p.type === 'currency');
        return symbolPart ? symbolPart.value : currencyCode;
    } catch (e) {
        return currencyCode;
    }
}

function formatPrice(price) {
    if (price === null || price === undefined || price === '') return '';
    const amount = parseFloat(price);
    if (isNaN(amount)) return '';
    //  Live active currency
    const activeCurrency = window.Shopify?.currency?.active || 'USD';
    // Get correct symbol: S$ for SGD, A$ for AUD, £ for GBP, etc.
    const symbol = getCurrencySymbol(activeCurrency);
    return symbol + amount.toFixed(2);
}

function isUnbxdPopularProductOutOfStock(product) {
    if (typeof window.isUnbxdAutosuggestProductOutOfStock === "function") {
        return window.isUnbxdAutosuggestProductOutOfStock(product);
    }
    if (!product) return false;
    const a = product.availability;
    if (a === false || a === "false" || String(a).toLowerCase() === "false") return true;
    if (product.inStock === false || product.inStock === "false") return true;
    if (product.unbxd_availability === "false") return true;
    if (Array.isArray(product.variants) && product.variants.length > 0) {
        const anyAvailable = product.variants.some((variant) => {
            if (!variant) return false;
            if (variant.availability === false || variant.availability === "false") return false;
            const availableForSale = variant.v_availableForSale;
            return availableForSale === true
                || availableForSale === "true"
                || availableForSale === 1
                || availableForSale === "1";
        });
        if (!anyAvailable) return true;
    }
    return false;
}

function escapeAttr(value) {
    if (value == null) return "";
    return String(value)
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
}

//  Now formatPrice is available inside y()
function y({ POPULAR_PRODUCTS: t = [] }) {
    const products = t || [];
    if (!products.length) return "";

    return `
        ${products.map((p, i) => {
            const price = parseFloat(p.price);
            const comparePrice = parseFloat(p.compare_at_price);
            const isOnSale = comparePrice && !isNaN(comparePrice) && comparePrice > price;
            const isOos = isUnbxdPopularProductOutOfStock(p);
            // ${isOos ? '<span class="unbxd-as-stock-badge">Out of stock</span>' : ''}
            return `
            <li class="unbxd-as-popular-product${isOos ? " unbxd-as-popular-product--oos" : ""}"
            data-doctype="POPULAR_PRODUCTS"
            data-value="${escapeAttr(p.title || p.autosuggest || p.productUrl || p.uniqueId || p.id || '')}"
            data-index="${i}"
            data-id="${escapeAttr(p.uniqueId || p.id || '')}">
                <a href="${p.productUrl}" class="unbxd-as-popular-product-link">
                    <div class="unbxd-as-popular-product-image-container">
                        <img src="${p.imageUrl}&width=400" />
                    </div>
                    <div class="UNX-product-info">
                        <div class="UNX-product-title">
                            <h3>${p.title}</h3>
                        </div>
                        <div class="unbxd-product-review">
                            <div class="klaviyo-star-rating-widget"
                                data-id="${p.uniqueId || p.id || ''}"
                                data-product-title="${p.title || ''}">
                            </div>
                        </div>
                        <div class="unbxd-as-popular-product-price">
                            ${isOnSale ? `
                                <span class="unbxd-as-discount price-green">
                                    ${formatPrice(price)}
                                </span>
                                <span class="unbxd-as-price sale-on">
                                    ${formatPrice(comparePrice)}
                                </span>
                            ` : `
                                <span class="unbxd-as-price ${comparePrice}">
                                    ${formatPrice(price)}
                                </span>
                            `}
                        </div>
                    </div>
                </a>
            </li>
            `;
        }).join("")}
    `;
}
   function v({
      PROMOTED_SUGGESTIONS: t = []
   }) {
      if (0 === t.length) return "";
      return `<div class="unx-promoted-suggestions">${t.map(t=>`<div class="unx-item unx-promoted-suggestion" data-doctype="PROMOTED_SUGGESTION" data-value="${t.autosuggest}">${t.autosuggest}</div>`).join("")}</div>`
   }

   function m({
      TOP_SEARCHES: t = []
   }) {
      if (0 === t.length) return "";
      return `<div class="unx-top-search-queries">${t.map(t=>`<div class="unx-item unx-top-search-query" data-doctype="TOP_SEARCH_QUERIES" data-value="${t.autosuggest}">${t.autosuggest}</div>`).join("")}</div>`
   }

   function E({
      TRENDING_SEARCHES: t = []
   }) {
      if (0 === t.length) return "";
      return `<div class="unx-trending-searches">${t.map(t=>`<div class="unx-item unx-trending-search">${t.autosuggest}</div>`).join("")}</div>`
   }
   class T {
      constructor({
         configurations: t,
         getState: e
      }) {
         this.configurations = t, this.getState = e, this.templates = {
            popularProducts: y,
            inFields: S,
            keywordSuggestions: f,
            promotedSuggestions: v,
            topSearchQueries: m,
            trendingSearches: E
         }, this.templates.autosuggestionBox = this.configurations?.suggestionBoxConfigs?.template?.bind(this) || this.AutosuggestionBoxTemplate.bind(this)
      }
      getTemplate(t) {
         return this.templates[t]
      }
      AutosuggestionBoxTemplate() {
         try {
            const {
               query: t,
               response: {
                  trendingSearches: e = [],
                  popularProducts: s = [],
                  keywordSuggestions: o = [],
                  promotedSuggestions: n = [],
                  topSearchQueries: r = [],
                  inFields: i = [],
                  products: u = []
               } = {}
            } = this.getState() || {};
            console.log("this.getTemplate----",this.getTemplate)
            if ((!t || 0 == t.trim().length) && e?.length > 0) {
               return this.getTemplate("trendingSearches").call(this, {
                  TRENDING_SEARCHES: e
               })
            }
            const a = s?.length > 0 ? this.getTemplate("popularProducts")({
                  POPULAR_PRODUCTS: s
               }) : "",
               g = i?.length > 0 ? this.getTemplate("inFields").call(this, {
                  IN_FIELD: i
               }) : "",
               c = o?.length > 0 ? this.getTemplate("keywordSuggestions")({
                  KEYWORD_SUGGESTION: o
               }) : "",
               h = n?.length > 0 ? this.getTemplate("promotedSuggestions")({
                  PROMOTED_SUGGESTIONS: n
               }) : "",
               l = r?.length > 0 ? this.getTemplate("topSearchQueries")({
                  TOP_SEARCHES: r
               }) : "";
            return `${a}<div class="unx-suggestions">${g}${c}${h}${l}</div>`
         } catch (t) {
            return console.error("TemplateService AutosuggestionBoxTemplate error", t), ""
         }
      }
      constructTrendingSearchesTemplate() {
         try {
            const t = this.getState(),
               {
                  response: {
                     trendingSearches: e
                  } = {}
               } = t || {};
            return this.getTemplate("trendingSearches").call(this, {
               TRENDING_SEARCHES: e
            })
         } catch (t) {
            return console.error("TemplateService constructTrendingSearchesTemplate error", t), ""
         }
      }
   }
   t.Autosuggest = class {
      constructor(t) {
         try {
            this.stateManager = new e, this.configManager = new n({
               configs: t
            });
            const s = this.configManager.getConfigs();
            this.apiService = new p({
               configurations: s,
               setState: this.stateManager.updateState.bind(this.stateManager),
               getState: this.stateManager.getState.bind(this.stateManager)
            }), this.templateService = new T({
               configurations: s,
               getState: this.stateManager.getState.bind(this.stateManager)
            }), this.domService = new d({
               configurations: s,
               getState: this.stateManager.getState.bind(this.stateManager),
               setState: this.stateManager.updateState.bind(this.stateManager),
               onAutosuggestionRequest: this.setupAutosuggestion.bind(this),
               onSearchRequest: this.fireSearchOnHover.bind(this),
               renderSuggestions: this.renderSuggestions.bind(this),
               renderPopularProductsOnly: this.renderPopularProductsOnly.bind(this),
               clearSuggestions: this.clearSuggestions.bind(this)
            })
         } catch (t) {
            console.error("Autosuggest constructor error", t)
         }
      }
      fireSearchOnHover({
         query: t,
         filters: e = []
      }) {
         return this.apiService.fireSearchRequest({
            query: t,
            filters: e
         })
      }
      async setupAutosuggestion({
         query: t
      }) {
         try {
            if (await this.apiService.fireAutosuggestRequest({
                  query: t
               }), this.renderSuggestions(), this.configManager.getConfigs("apiConfigs.search.prefetch")) {
               const {
                  response: {
                     inFields: t = [],
                     keywordSuggestions: e = [],
                     promotedSuggestions: s = [],
                     topSearchQueries: o = []
                  } = {}
               } = this.stateManager.getState() || {};
               [...t, ...e, ...s, ...o].map(t => {
                  const {
                     autosuggest: e,
                     [this.configManager.getConfigs("apiConfigs.search.filterField") + "_in"]: s
                  } = t;
                  this.apiService.fireSearchRequest({
                     query: e,
                     ...s ? {
                        filters: s
                     } : {}
                  })
               })
            }
         } catch (t) {
            console.error("handleAutosuggestRequest error", t)
         }
      }
      renderSuggestions() {
         try {
            const {
               query: t = "",
               response: {
                  trendingSearches: e = [],
                  initialRequestProducts: s = [],
                  products: o = []
               } = {}
            } = this.stateManager.getState(), {
               minChars: i
            } = this.configManager?.getConfigs("inputBoxConfigs") || this.configs?.inputBoxConfigs || {}, u = null != i ? i : 3, a = (t || "").trim();
            if (!a || a.length < u) return void this.domService.unmountAutosuggestionBox();
            const n = !a || 0 === a.length;
            if (n && 0 === e?.length && 0 === s?.length || a?.length > 0 && (o?.length ?? 0) <= 0) return void this.domService.unmountAutosuggestionBox();
            const r = this.templateService.getTemplate("autosuggestionBox")(this.stateManager.getState());
            this.domService.updateSuggestionBoxHTML(r), this.domService.mountAutosuggestionBox();
         } catch (t) {
            console.error("Autosuggest renderSuggestions error", t)
         }
      }
      renderPopularProductsOnly() {
         try {
            const {
               response: {
                  popularProducts: t = []
               } = {}
            } = this.stateManager.getState() || {}, e = this.templateService.getTemplate("popularProducts")({
               POPULAR_PRODUCTS: t
            });
            this.domService.updatePopularProductsSection(e);
         } catch (t) {
            console.error("Autosuggest renderPopularProductsOnly error", t)
         }
      }
      clearSuggestions() {
         try {
            this.stateManager.updateState("response__products", []), this.stateManager.updateState("response__popularProducts", []), this.stateManager.updateState("response__inFields", []), this.stateManager.updateState("response__keywordSuggestions", []), this.stateManager.updateState("response__promotedSuggestions", []), this.stateManager.updateState("response__topSearchQueries", [])
         } catch (t) {
            console.error("Autosuggest clearSuggestions error", t)
         }
      }
   }
});